// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24mND","toggleWrap":"styles_toggleWrap__1Yyrl","content":"styles_content__3JvtY","selectAreaCode":"styles_selectAreaCode__34M7c"};